<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle"><a id="page_i"></a><span class="bold">VICTIMS OF THE</span></p>
<p class="half"><span class="bold">OAKS</span></p>
<p class="subtitle1"><span class="bold">COLLIERY</span></p>
<p class="subtitle2"><span class="bold">DISASTER 1847</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?8af2b2aa